import useTransactionsStore from '@/store/modules/transactions';
import { useAuthStore } from '@/store/modules/auth';
import { useKycStore } from '@/store/modules/kyc';
import { defineComponent, onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import router from '@/router';
import { Button } from '@yellowcard/components-library-vue3';
import TransactionItemComponent from '@/components/transaction/TransactionItemComponent.vue';
import LoaderComponent from '@/components/general/LoaderComponent.vue';
import NoTransactions from '@/components/transaction/NoTransactions.vue';
import VerificationStatusApproved from '@/components/transaction/VerificationStatusApproved.vue';
import VerificationPending from '@/components/transaction/VerificationStatusPending.vue';
import VerificationStatusFailed from '@/components/transaction/VerificationStatusFailed.vue';
import { KycTypes } from '@/types/kyc';
import { TransactTypes } from '@/types/transact';
var TransactionType = TransactTypes.TransactionType;
export default defineComponent({
    name: 'ListTransactions',
    components: {
        Button,
        TransactionItemComponent,
        NoTransactions,
        VerificationStatusApproved,
        VerificationPending,
        LoaderComponent,
        VerificationStatusFailed,
    },
    setup() {
        const transactionsStore = useTransactionsStore();
        const { userTransactions, loading, currentStep, selectedCurrencyAmount, selectedCryptoAmount, txType, fetchingUserTransactions, } = storeToRefs(transactionsStore);
        const kycStore = useKycStore();
        const { kycStatus } = storeToRefs(kycStore);
        const authStore = useAuthStore();
        const { sellEnabled } = storeToRefs(authStore);
        onMounted(async () => {
            await transactionsStore.getUserTransactions();
        });
        const onAllTransactionsClickListener = () => {
            router.push('/transactions');
        };
        const onKeyPress = () => {
            console.log('key press');
        };
        const onSellCryptoClicked = () => {
            if (sellEnabled.value) {
                txType.value = TransactionType.SELL;
                selectedCurrencyAmount.value.amount = 0;
                selectedCryptoAmount.value.amount =
                    transactionsStore.calculateCryptoAmount(selectedCurrencyAmount.value.amount);
                currentStep.value = TransactTypes.TransactSteps.BUY_1;
                router.push('/transact'); // navigate to buy crypto view
            }
            else {
                router.push('/sell');
            }
        };
        const onBuyCryptoClicked = () => {
            txType.value = TransactionType.BUY;
            selectedCurrencyAmount.value.amount = 0;
            selectedCryptoAmount.value.amount =
                transactionsStore.calculateCryptoAmount(selectedCurrencyAmount.value.amount);
            currentStep.value = TransactTypes.TransactSteps.BUY_1;
            router.push('/transact'); // navigate to buy crypto view
        };
        return {
            userTransactions,
            onAllTransactionsClickListener,
            onKeyPress,
            kycStatus,
            KycTypes,
            onSellCryptoClicked,
            onBuyCryptoClicked,
            loading,
            fetchingUserTransactions,
        };
    },
});
